import { useTranslation } from "react-i18next";

const PULSE = "animate-pulse bg-ds-mist/60 motion-reduce:animate-none";

/**
 * Lo que se ve mientras la ficha viaja.
 *
 * Tiene la MISMA forma que la ficha real —el estandarte ancho arriba, la
 * compra a la derecha, el texto a la izquierda— y no un spinner centrado:
 * cuando llegan los datos, nada se mueve de sitio y el botón de añadir al
 * carrito aparece donde el ojo ya estaba mirando.
 *
 * Lo que NO imita son los bloques editoriales de abajo. La mayoría de los
 * productos no los tiene, así que dibujar cuatro secciones fantasma
 * prometería una ficha larga que en la mitad de los casos termina antes —
 * y el salto al desaparecer es peor que no haberlas dibujado.
 *
 * El bloque entero es una sola región `aria-busy` con un texto para el
 * lector de pantalla; ocho cajas grises no le dicen nada a nadie.
 */
export function ProductDetailSkeleton() {
  const { t } = useTranslation();

  return (
    <div role="status" aria-busy="true" className="grid gap-10 sm:gap-14">
      <span className="sr-only">{t("Cargando el producto…")}</span>

      <div
        aria-hidden="true"
        /*
         * El esqueleto reserva el alto REAL del estandarte —78vh, el del
         * original— y no una altura fija. Con 420 px la ficha daba un
         * salto largo al llegar la respuesta, que es justo lo que un
         * esqueleto existe para evitar.
         */
        className={`h-[78vh] rounded-ds-xl ${PULSE}`}
      />

      <div
        aria-hidden="true"
        className="grid gap-10 lg:grid-cols-[1.2fr_0.8fr] lg:gap-14"
      >
        <div className="grid content-start gap-4 rounded-[4px] border border-ds-border bg-white p-6 lg:col-start-2 lg:row-start-1">
          <div className={`h-9 w-40 rounded-ds-sm ${PULSE}`} />
          <div className={`h-12 w-full rounded-ds-pill ${PULSE}`} />
        </div>

        <div className="grid content-start gap-4 lg:col-start-1 lg:row-start-1">
          <div className={`h-3 w-28 rounded-ds-sm ${PULSE}`} />
          <div className={`h-9 w-3/4 rounded-ds-sm ${PULSE}`} />
          <div className={`h-3 w-full rounded-ds-sm ${PULSE}`} />
          <div className={`h-3 w-full rounded-ds-sm ${PULSE}`} />
          <div className={`h-3 w-2/3 rounded-ds-sm ${PULSE}`} />
        </div>
      </div>
    </div>
  );
}
